const { default: getHighchartsBundle } = require("../lazy-bundles/load-highcharts-bundle");

/**
 * Stores all of the charts to be rendered on the Fund Listing page
 */
window.feCharts = {
    loadedCharts: [],
    currentChart: {
        chartTitle: "",
        dataSet: [],
        seriesName: "",
        color: "",
        xAxisTitle: "",
        yAxisTitle: "",
        tooltipSuffix: ""
    },


    /**
 * Renders the basic chart skeleton, but not the chart.
 *
 * @param {any} chartType
 * @param {any} row
 */
    rnChartArea: function (chartType, row, tickerGroup, displayTicker) {
        //Pass a display ticker when the Fund Ticker being displayed is different from the actual Fund Ticker being passed to the Chart Data API.
        displayTicker = displayTicker || row.ExpandableContent.Ticker;
        const newDesign = document.querySelector('.etf-fund-page-redesign');

        switch (chartType) {
            case "premium-discount":
                var tabIDprefix = "the-prem-tab-";
                var chartTitle = displayTicker + " Premium or Discount (bps): <span id='current-quarter'></span>";

                var downloadLink = "";

                var tabs = '<ul class="tabs__items nav nav-tabs chart-tabs" role="tablist" id="tabs-for-' + row.ExpandableContent.Ticker + '" data-ticker="' + row.ExpandableContent.Ticker + '" data-chart-type="' + chartType + '">';

                row.ExpandableContent.Quarters.forEach(function (e, i) {
                    tabs += '<li class="nav-item nav-' + row.ExpandableContent.Ticker + '"> <a class="nav-link premium-discount-quarter" id="' + e.Value + '-tab" data-quarter="' + e.Value + '" role="tab" aria-controls="Last11Year" aria-selected="">' + e.Name + '</a></li>';
                });

                tabs += '</ul >';

                var datePicker = ''; //no date picker for premium discount
                break;
            case "price":
            case "growth-10k-campaign-pages":
              var tabIDprefix = "the-tab-";
                var title = "Nav Chart";
                if (typeof tickerGroup === "string") {
                    title = tickerGroup.toLowerCase() === "index" ? "Price Chart" : title;
                }

                var chartTitle = displayTicker + " - " + title;

                var downloadLink = "<div class='expandable-download-link'><a class='font-weight-normal' href='" + row.ExpandableContent.DownloadUrl + "'>Download NAV History</a></div>";

                var inceptionDate = new Date(row.ExpandableContent.InceptionDate);

                var periods = feCharts.getPricePeriods(inceptionDate, row);
                
                var tabs = '<div class="tabs-header" id="tabs-header"><ul class="tabs__items nav nav-tabs chart-tabs" role="tablist" id="tabs-for-' + row.ExpandableContent.Ticker + '" data-ticker="' + row.ExpandableContent.Ticker + '" data-chart-type="' + chartType + '">';
                
                var activePeriodId = periods[periods.length - 1]?.id ?? "sinceInception";
                
                periods.forEach((e, i) => {
                  var isActive = e.id === activePeriodId ? "active" : ""
                  tabs += `<li 
                    class="nav-item nav-${row.ExpandableContent.Ticker} ${isActive }"> 
                    <a class="nav-link price-period" 
                      id="${row.ExpandableContent.Ticker}-${e.id}-tab" 
                      data-start-date="${e.startDate}" 
                      role="tab" 
                      aria-selected="false">${e.name}</a>
                    </li>`;
                });

                var now = new Date();
                var endDateText = ('0' + now.getDate()).slice(-2) + '/' + ('0' + (now.getMonth() + 1)).slice(-2) + '/' + now.getFullYear();

                var datePicker = `
                    <div class="row d-flex justify-content-center">
                        <div class="datepicker" id="daterange-${row.ExpandableContent.Ticker}-prices">
                            <span class="datepicker-date datepicker-start-date active-date active"
                                  id="start-date-${row.ExpandableContent.Ticker}-prices"
                                  data-ticker="${row.ExpandableContent.Ticker}"
                                  data-chart-type="${chartType}"
                                  type="button">
                                ${row.ExpandableContent.InceptionDate}
                            </span>
                            <span class="datepicker-date datepicker-end-date active-date active"
                                  id="end-date-${row.ExpandableContent.Ticker}-prices"
                                  data-ticker="${row.ExpandableContent.Ticker}"
                                  data-chart-type="${chartType}"
                                  type="button">
                                ${endDateText}
                            </span>
                        </div>
                    </div>
                `;
                tabs += `</ul >${datePicker}</div>`;

                break;
            case "growth-10k":
                var tabIDprefix = "the-tab-";
                var title = "Nav Chart";
                if (typeof tickerGroup === "string") {
                    title = tickerGroup.toLowerCase() === "index" ? "Price Chart" : title;
                }

                var chartTitle = displayTicker + " - " + title;

                var downloadLink = "<div class='expandable-download-link'><a class='font-weight-normal' href='" + row.ExpandableContent.DownloadUrl + "'>Download NAV History</a></div>";

                var inceptionDate = new Date(row.ExpandableContent.InceptionDate);

                var periods = feCharts.getPricePeriods(inceptionDate, row);

                var changeDateText = window.ve10kChartOverrides?.ChangeDateText ?? "CHANGE DATE RANGE";
                var dateFormatString = window.ve10kChartOverrides?.IsEuFund ? "(DD/MM/YYYY) - (DD/MM/YYYY)" : "(MM/DD/YYYY) - (MM/DD/YYYY)";

                const ucitsPerformance = document.querySelector('.ucits-performance-block');
                const datePickerBtn = `<button 
                                  class="datepicker-btn btn btn-link" 
                                  data-inception-date="${row.ExpandableContent.InceptionDate}" 
                                  id="date-${row.ExpandableContent.Ticker}-prices" 
                                  data-ticker="${row.ExpandableContent.Ticker}" 
                                  data-chart-type="${chartType}" 
                                  type="button"
                                >
                                  ${changeDateText}
                                </button>`

                var datePicker = '<div class="d-none"><div class="datepicker" id="daterange-' + row.ExpandableContent.Ticker + '-prices" ><span class="datepicker-date active-date active">' + dateFormatString +`</span></div>${datePickerBtn}</div>`; //TODO[AM]: temp fix to make tabs work, including datepicker but not displaying as functionality needs work

                var tabs = '<ul class="tabs__items nav nav-tabs chart-tabs" role="tablist" id="tabs-for-' + row.ExpandableContent.Ticker + '" data-ticker="' + row.ExpandableContent.Ticker + '" data-chart-type="' + chartType + '">';

                var activePeriodId = newDesign 
                    ? (periods.find(p => p.id === "threeYear")?.id ?? "sinceInception")
                    : (periods[periods.length - 1]?.id ?? "sinceInception");

                periods.forEach((e, i) => {
                    const isActive = e.id === activePeriodId ? "active" : "";

                    let tab = `
                      <li class="nav-item nav-${row.ExpandableContent.Ticker}">
                        <a 
                          class="nav-link price-period ${isActive}" 
                          id="${row.ExpandableContent.Ticker}-${e.id}-tab" 
                          data-start-date="${e.startDate}" 
                          role="tab" 
                          aria-selected="${isActive ? 'true' : 'false'}"
                        >
                          ${e.name}
                        </a>
                          ${
                            newDesign && e.id === 'sinceInception' && !ucitsPerformance
                              ? datePickerBtn
                              : ''
                          }
                      </li>
                    `;

                    tabs += tab;
                });

                tabs += '</ul >';

                break;
            default:
                console.error("Unknown chart type:" + chartType);
                return "";
        }

        var chartHeader = '<h4 class="mb-0" id="chart-title-' + row.ExpandableContent.Ticker + '">' + chartTitle + '</h4>' + downloadLink + '<div class="fund-explorer-table__graph row"> <div class="fund-explorer-table__graph-tab col-12"> <div class="tabs">';

        if (chartType == "growth-10k" || chartType == "growth-10k-campaign-pages") {
            //we don't use a title nor do we use a download link for the growth of 10k chart area. Currently used only on fund pages.
            chartHeader = '<div class="fund-explorer-table__graph row"> <div class="fund-explorer-table__graph-tab col-12"> <div class="tabs">';
        }

        //var tabs is declated above.

        /* We are only rendering one tab and using JS to re-render the chart on the same tab, hence disabling the BS Tabs functionality. */
        var tabContent = '<div class="tabs__content tab-content"> <div class="tab-pane fade active show" id="' + tabIDprefix + row.ExpandableContent.Ticker + '" role="tabpanel"  aria-labelledby="nav-list-' + row.ExpandableContent.Ticker + '"> Loading... </div> </div >';

        var headerClose = '</div></div>';

        if (newDesign) return chartHeader + tabs + tabContent + headerClose;

        return chartHeader + tabs + tabContent + datePicker + headerClose; //TODO[AM]: temp fix to make tabs work, including datepicker but not displaying as functionality needs work
    },


    loadData: function(renderContainer, ticker, chartType, quarter, startDate, endDate, blockID, isEuTicker, tooltipPrefix, chartValueText, noDataText, specialNoDataText) {
        /**
         * Guard clauses
         */

        if (typeof ticker != "string") return console.error("Can't load chart without ticker.");
        if (typeof chartType != "string") return console.error("Can't load chart without chart type.");
        if (typeof renderContainer != "string") return console.error("Can't load chart without a rendering container.");
        var url = "/Main/FundListingUs/GetChartData";
        var mkDates = "";
        var mkQuarter = "";
        var g10koptions = null;

        switch (chartType) {
        case "premium-discount":
            if (typeof quarter != "string") return console.error("Can't load chart without chart type.");
            mkQuarter = '"Quarter":"' + quarter + '",';
            break;
        case "price":
        case "PriceWithDecimal":
            if (typeof startDate == "undefined" || typeof endDate == "undefined")
                return console.error("Can't load chart without a starting and ending date.");
            mkDates = '"StartTime":"' + startDate + '","EndTime":"' + endDate + '",';
            break;
        case "growth-10k":
                if (typeof startDate == "undefined" || typeof endDate == "undefined") return console.error("Can't load chart without a starting and ending date.");
                if (typeof ve10kcharts == "undefined" || !blockID) return console.error("Can't load chart without 10k chart options object loaded or blockID.");
                g10koptions = ve10kcharts.find(x => x.blockId == blockID);
                if(!g10koptions) return console.error("Couldn't find 10k chart options object.");
            break;
        case "growth-10k-campaign-pages":
                if (typeof startDate == "undefined" || typeof endDate == "undefined") return console.error("Can't load chart without a starting and ending date.");
                if (typeof ve10kcharts == "undefined" || !blockID) return console.error("Can't load chart without 10k chart options object loaded or blockID.");
                g10koptions = ve10kcharts.find(x => x.blockId == blockID);
                if(!g10koptions) return console.error("Couldn't find 10k chart options object.");
            break;
        default:
            return console.error("Unknown chart type: " + chartType);
        }

        /*
         * For the Growth of 10k chart, where the API is slightly older.
         * */
        if (chartType == "growth-10k" || chartType == "growth-10k-campaign-pages") {
            g10koptions.ajaxOptions.data.startDate = startDate;
            g10koptions.ajaxOptions.data.endDate = endDate;

            return $.ajax(g10koptions.ajaxOptions).done(async function (data, response) {
                feCharts.loadedCharts.push(await feCharts.processData({
                        ChartType: chartType,
                        Ticker: data[0]?.name,
                        ChartData: data[0]?.data,
                        XAxisTitle: window["linechartoptions" + blockID]?.xAxis?.title?.text,
                        XAxisLabelsFormatter: isEuTicker ? window["linechartoptions" + blockID]?.xAxis?.labels?.formatter : null,
                        YAxisTitle: "",
                        YAxisLabelsFormatter: window["linechartoptions" + blockID]?.yAxis?.labels?.formatter,
                        TooltipPrefix: tooltipPrefix,
                        TooltipFormatterMethod: null,
                        TooltipFormatter: isEuTicker ? "euTooltip" : "",
                        responseData: data,
                        NoDataText: noDataText,
                        SpecialNoDataText: specialNoDataText
                    }, renderContainer));
            });

        }

    /**
     * All other charts continue here
     * */

    var mkTicker = '"Ticker":"' + ticker + '",';
        var mkChartType = '"ChartType":"' + chartType + '"';

        /**Payload needs to be in the string format required by Prabhu... */
        var payload = {
            'filterJson':
                "{" + mkTicker + mkDates + mkQuarter + mkChartType + "}"
        }


        $.post(url, payload).done(async function(data, response) {
            if (typeof data.Result != "object" || !data.Result?.length) return console.error("The response was not expected.");
            feCharts.loadedCharts.push(await feCharts.processData(data.Result[0], renderContainer));
            feutils.spinner.hide();
        }).fail(feCharts.ajaxFail);

    },

    ajaxFail: function(e) {
        console.error("The response returned an error!");
        feutils.spinner.hide();
        console.log(e);
    },

    processData: async function(data, renderSlr) {
        if (typeof data != "object") return console.error("Chart details expected!");
        if (typeof data.ChartData === "undefined" || data.ChartData.length === 0) {
            /* There is no data */
            var noDataMessage = data.SpecialNoDataText
                ? '<div class="w-100 text-center text-primary my-6">' + (data.SpecialNoDataText ?? 'There is no data for the selected date range.') + '</div>'
                : '<div class="w-100 text-center text-primary my-6">' + (data.NoDataText ?? 'There is no data for the selected date range.') + '</div>';
            $(renderSlr).html(noDataMessage);
            return [];
        }

        var dataSet = [];
        data.ChartData.forEach(function(e, i) {
            var s = e.split(",");
            var date = Date.UTC(s[0], s[1], s[2], 4); /* UTC + 4 hours = ET */
            var val = Number(s[3]);
            val = isNaN(val) ? 0 : val;
            dataSet.push([date, val]);
        });
        var ChartData = {};

        //check if the dataset is less than 3 months
        var startDate = new Date(dataSet[0][0]);
        var endDate = new Date(dataSet[dataSet.length - 1][0]);
        var dateSpan = endDate - startDate;
        dateSpan = dateSpan < 1 ? dateSpan * -1 : dateSpan;
        var smallPeriod = (dateSpan < 1000 * 60 * 60 * 24 * 130); //Approx 130 days
console.log(data.ChartType)
        switch (data.ChartType) {
            case "premium-discount":
                ChartData = {
                    chartTitle: false, //data.Name + " Premium or Discount (bps)",
                    dataSet: dataSet,
                    seriesName: data.Ticker,
                    color: data.Color || "#17468f",
                    xAxisTitle: data.XAxisTitle,
                    yAxisTitle: data.YAxisTitle,
                    tooltipSuffix: "%",
                    tooltipPrefix: "",
                    xAxisLabelFormat: smallPeriod ? "{value: %b %e %Y}" : "{value: %b-%Y}",
                    tooltipFormatter: "price"
                }
                break;
            case "growth-10k":
                ChartData = {
                    chartTitle: false, //data.Name + " Premium or Discount (bps)",
                    dataSet: dataSet,
                    seriesName: data.Ticker,
                    color: data.Color || "#17468f",
                    xAxisTitle: data.XAxisTitle,
                    xAxisLabelsFormatter: data.XAxisLabelsFormatter,
                    yAxisTitle: data.YAxisTitle,
                    yAxisLabelsFormatter: data.YAxisLabelsFormatter,
                    tooltipSuffix: "",
                    tooltipPrefix: data.TooltipPrefix ?? window.ve10kChartOverrides?.CurrencySymbol ?? "$",
                    xAxisLabelFormat: smallPeriod ? "{value: %b %e %Y}" : "{value: %b %Y}",
                    tooltipFormatter: data.TooltipFormatter ? data.TooltipFormatter : "price",
                    tooltipFormatterMethod: data.TooltipFormatterMethod,
                    responseData: data.responseData,
                    floatingLegend: true,
                    chartHeight: 450,
                }
                break;
                case "growth-10k-campaign-pages":
                ChartData = {
                    chartTitle: false, // data.Name + " Premium or Discount (bps)",
                    dataSet: dataSet,
                    seriesName: data.Ticker,
                    color: data.Color || "#17468f",
                    xAxisTitle: data.XAxisTitle,
                    xAxisLabelsFormatter: data.XAxisLabelsFormatter,
                    yAxisTitle: data.YAxisTitle,
                    yAxisLabelsFormatter: data.YAxisLabelsFormatter,
                    tooltipSuffix: "",
                    tooltipPrefix: data.TooltipPrefix ?? window.ve10kChartOverrides?.CurrencySymbol ?? "$",
                    xAxisLabelFormat: smallPeriod ? "{value: %b %e %Y}" : "{value: %b-%Y}",
                    tooltipFormatter: data.TooltipFormatter ? data.TooltipFormatter : "price",
                    tooltipFormatterMethod: data.TooltipFormatterMethod,
                    responseData: data.responseData,
                    floatingLegend: false,
                    chartHeight: 450,
                    isCampaignStyle: true,
                }
                break;
            case "price":
            case "PriceWithDecimal":
                ChartData = {
                    chartTitle: false, //data.Name + " Premium or Discount (bps)",
                    dataSet: dataSet,
                    seriesName: data.Ticker,
                    color: data.Color || "#17468f",
                    xAxisTitle: data.XAxisTitle,
                    yAxisTitle: data.YAxisTitle,
                    tooltipSuffix: "",
                    tooltipPrefix: "$",
                    xAxisLabelFormat: smallPeriod ? "{value: %b %e %Y}" : "{value: %b-%Y}",
                    tooltipFormatter: "nav"
                }
                break;
            default:
                return console.error("Unidentified chart type: " + data.ChartType);
        }

        feCharts.currentChart = ChartData;
        return await feCharts.rnChart($(renderSlr)[0]);

    },

    activateTabListeners: function() {
        $('ul.chart-tabs').each(function(i, e) {
            var chartType = $(e).data('chart-type');
            var ticker = $(e).data('ticker');

            switch (chartType) {
            case "growth-10k":
                    //price chart is triggered by listening for a datepicker change. see growth-10k.js
                    break;
            case "growth-10k-campaign-pages":
                    //price chart is triggered by listening for a datepicker change. see growth-10k.js
                    break;
            case "premium-discount":
                var tabslr = "#tabs-for-" + ticker + " .premium-discount-quarter";
                    $(tabslr).click(function () {
                        feutils.spinner.show();
                        $(this).parent().parent().find('a.nav-link').removeClass('active');
                        $(this).addClass('active');
                    var quarter = $(this).data("quarter");
                    var container = "#the-prem-tab-" + ticker;
                    feCharts.loadData(container, ticker, chartType, quarter, false, false);
                    $('#chart-title-' + ticker + ' > #current-quarter').text(quarter);
                });
                break;
                case "price":
                    //price chart is triggered by listening for a datepicker change. see scripts.js
                break;
            default:
                return;
            }
        });

        $('.expandable-content-pane').on('shown.bs.collapse',
            function() {
                var activePriceElem = $(this).find('a.nav-link.price-period.active');
                $(this).find('a.nav-link.premium-discount-quarter').first().click();
                $(this).find('.datepicker-btn').trigger('apply.daterangepicker');
                //the first time make the "since inception" active again, regardless of daterangepicker removing it...
                if (activePriceElem.length === 1) {
                    window.setTimeout(function() {
                        activePriceElem.addClass("active");
                    }, 20)
                }
            }).on('hidden.bs.collapse', function() {
            //delete the chart
            $(this).find('.tab-pane.active').first().empty();
        });
    },

    //precision rounding
    mathRound: function(num) {
        var m = Number((Math.abs(num) * 100).toPrecision(15));
        return Math.round(m) / 100 * Math.sign(num);
    },


    rnChart: async function (containerElm) {
        const newDesign = document.querySelector('.etf-fund-page-redesign');
        //Enable standard markers for line charts, instead of the default symbols.
        Highcharts.seriesTypes.line.prototype.drawLegendSymbol = Highcharts.seriesTypes.column.prototype.drawLegendSymbol;

        var currentChart = feCharts.currentChart;
console.log(currentChart);
        if (currentChart.isCampaignStyle) {
            await getHighchartsBundle();

            let seriesSet = [];

            if (currentChart.responseData && currentChart.responseData.length) {
                const value = currentChart.responseData[0];
                const color = value.color || currentChart.color;

                const series = {
                    name: value.name,
                    color,
                    data: [],
                    showInLegend: false,
                    fillColor: {
                        linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                        stops: [
                            [0, "#001e6d"],
                            [1, "#09a3ae"]
                        ]
                    },
                    lineWidth: 2,
                    marker: { enabled: false }
                };

                $.each(value, function (key, val) {
                    if (Array.isArray(val)) {
                        $.each(val, function (i, d) {
                            var parts = d.split(",");
                            var x = Date.UTC(parts[0], parts[1], parts[2]);
                            var y = parts[3] === 'null' ? null : parseFloat(parts[3]);
                            series.data.push([x, y]);
                        });
                    }
                });

                seriesSet.push(series);
            }

            return new Highcharts.Chart({
                chart: {
                    renderTo: containerElm,
                    type: 'area',
                    height: currentChart.chartHeight ?? 450,
                    backgroundColor: 'transparent'
                },
                title: {
                    text: currentChart.chartTitle || undefined
                },
                xAxis: {
                    lineColor: '#323232',
                    labels: feCharts.getXAxisLabels(currentChart),
                    title: {
                        text: currentChart.xAxisTitle,
                        style: { color: '#323232' }
                    },
                    crosshair: {
                        color: "#001e6d",
                        width: 1,
                        dashStyle: "Dash",
                        zIndex: 5
                    }
                },
                yAxis: {
                    title: {
                        text: currentChart.yAxisTitle,
                        style: { color: '#323232' }
                    },
                    labels: feCharts.getYAxisLabels(currentChart),
                    gridLineColor: '#e6e6e6',
                    lineWidth: 0,
                    opposite: false
                },
                tooltip: {
                    backgroundColor: "#001e6d",
                    style: {
                        color: "#ffffff",
                        fontWeight: "bold",
                        fontSize: "13px"
                    },
                    borderRadius: 4,
                    borderWidth: 0,
                    padding: 10,
                    useHTML: false,
                    formatter: function () {
                        var y = currentChart.tooltipPrefix + feCharts.mathRound(this.y).toFixed(2) + currentChart.tooltipSuffix;
                        return Highcharts.dateFormat('%d.%m.%y', this.x) + '<br/>' + y;
                    }
                },
                legend: { enabled: false },
                plotOptions: {
                    area: {
                        marker: { enabled: false },
                        lineWidth: 2,
                        threshold: null
                    },
                    series: { 
                        marker: { enabled: false }
                    }
                },
                credits: { enabled: false },
                exporting: false,
                series: seriesSet
            });
        }

        var seriesSet = [];
        //first and default series
        seriesSet.push({
            name: currentChart.seriesName,
            data: currentChart.dataSet,
            color: currentChart.color
        })

        //growth of 10k has an additional series. Here we use a custom parsing algorithem to parse and add the data.
        if (feCharts.currentChart.responseData && feCharts.currentChart.responseData.length) {
            seriesSet = [];
            feCharts.currentChart.responseData.forEach((value, key) => {
                series = { data: [] };
                $.each(value, function (key, val) {
                    switch (key) {
                        case "name":
                            series.name = val;
                            break;
                        case "color":
                            series.color = val;
                            break;
                        case "showInLegend":
                            series.showInLegend = val;
                            break;
                        case "marker":
                            series.marker = {};
                            series.marker.enabled = val.enabled;
                            series.marker.symbol = val.symbol;
                            break;
                        default:
                            $.each(val, function (key, val) {
                                var d = val.split(",");
                                var x = Date.UTC(d[0], d[1], d[2]);
                                if (d[3] === 'null') {
                                    series.data.push([x, null]);
                                }
                                else {
                                    series.data.push([x, parseFloat(d[3])]);
                                }
                            });
                            break;
                    }
                });

                var getDivisor = function (total) {
                    return Math.min(Math.round(total / 400), 4) || 1;
                }

                //Manually sample out the data to target about 300-500 data points.
                //However the divisor is capped at 4 as we do not want to sample less than 1/4
                var lastitem = series.data[series.data.length - 1];
                var divisor = getDivisor(series.data.length);
                series.data = series.data.filter(function (e, i) { return (i % divisor) === 0 })
                series.data.push({
                    x: lastitem[0],
                    y: lastitem[1],
                    labelrank: 1000
                });

                seriesSet.push(series);
            });
            const customLineChartColours = feutils.veColors //window.ve10kChartOverrides?.IsEuFund ? feutils.veColors : ["#17468F", "#108A12"]
            seriesSet.forEach((e, i) => {
                seriesSet[i].color = customLineChartColours[i];
            });
        }

        await getHighchartsBundle()

        if (window.ve10kChartOverrides?.IsEuFund) {
            Highcharts.setOptions({
                lang: {
                    decimalPoint: window.ve10kChartOverrides?.NumberDecimalSeparator,
                    thousandsSep: window.ve10kChartOverrides?.NumberGroupSeparator,
                    months: JSON.parse(window.ve10kChartOverrides?.FullMonths),
                    shortMonths: JSON.parse(window.ve10kChartOverrides?.ShortMonths),
                    weekdays: JSON.parse(window.ve10kChartOverrides?.WeekDays),
                    shortWeekdays: JSON.parse(window.ve10kChartOverrides?.ShortWeekdays),
                }
            });
        }

        if (newDesign && currentChart.floatingLegend && seriesSet.length > 1) {
            $(containerElm).parent().find('.chart-legend-container').remove();
            $(containerElm).wrap('<div style="position: relative;"></div>');
            
            var uniqueId = 'legend-' + Date.now();
            var legendHTML = `
                <div id="${uniqueId}" class="chart-legend-container">
                    <div class="custom-legend">
                        <div class="legend-header">
                            <span>Compare</span>
                            <span class="legend-toggle">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                                    <path d="M297.4 470.6C309.9 483.1 330.2 483.1 342.7 470.6L534.7 278.6C547.2 266.1 547.2 245.8 534.7 233.3C522.2 220.8 501.9 220.8 489.4 233.3L320 402.7L150.6 233.4C138.1 220.9 117.8 220.9 105.3 233.4C92.8 245.9 92.8 266.2 105.3 278.7L297.3 470.7z"/>
                                </svg>
                            </span>
                        </div>
                        <div class="legend-items">
                            ${seriesSet.map((series, index) => `
                                <div class="legend-item" data-series-index="${index}">
                                    <input type="checkbox" 
                                          id="legend-checkbox-${uniqueId}-${index}" 
                                          checked>
                                    <label for="legend-checkbox-${uniqueId}-${index}">
                                        <span class="series-color" style="background-color: ${series.color};"></span>
                                        ${series.name}
                                    </label>
                                </div>
                            `).join('')}
                        </div>
                    </div>
                </div>
            `;
            
            $(containerElm).parent().append(legendHTML);
        }
        
        const legendOptions = () => {
/*          if (newDesign) return {
              enabled: false,
          }*/

          return {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'top',
                x: -5,
                y: 20,
                floating: currentChart.floatingLegend ?? false,
                borderWidth: 1,
                backgroundColor: '#FFFFFF',
                shadow: true,
                useHTML: true,
          }
        }
        var chart = new Highcharts.Chart({
            chart: {
                renderTo: containerElm,
                type: 'line',
                height: currentChart.chartHeight ?? 350,
                backgroundColor: "rgba(0, 0, 0, 0)"
            },
            colors: [currentChart.color],
            title: {
                text: currentChart.chartTitle ? currentChart.chartTitle : undefined
            },
            xAxis: {
                lineColor: '#323232',
                labels: feCharts.getXAxisLabels(currentChart),
                title: {
                    text: currentChart.xAxisTitle,
                    style: {
                        color: '#323232'
                    }
                }
            },
            yAxis: {
                title: {
                    text: currentChart.yAxisTitle,
                    style: {
                        color: '#323232'
                    }
                },
                accessibility: {
                    description: 'trends in premiums and discounts for ' +
                        $('.hidden_data_feilds').find('.hdnNameClass').val() +
                        '. A negative number indicates that the funds shares sold at a discount to NAV; a positive number indicates the shares sold at a premium'
                },
                lineColor: '#323232',
                lineWidth: 1,
                labels: feCharts.getYAxisLabels(currentChart),
                maxPadding:0.2
            },
            tooltip: {
                formatter: currentChart.tooltipFormatterMethod ? currentChart.tooltipFormatterMethod : function () {
                    var y = currentChart.tooltipPrefix + Highcharts.numberFormat(this.y, 2, '.', ',') + currentChart.tooltipSuffix;
                    switch (currentChart.tooltipFormatter) {
                        case "nav":
                            return '<strong>' +
                                this.series.name +
                                '</strong><br/>' +
                                Highcharts.dateFormat('%a, %b %e %Y', this.x) +
                                ' : ' + y;
                        case "euTooltip":
                            y = currentChart.tooltipPrefix + Highcharts.numberFormat(this.y, 0, ',') + currentChart.tooltipSuffix;
                            return '<strong>' +
                                this.series.name +
                                '</strong><br/>' +
                                Highcharts.dateFormat('%a, %e %b %Y', this.x) +
                                ' : ' + y;
                        case "price":
                        default:
                            return '' +
                                this.series.name +
                                ' : ' +
                                Highcharts.dateFormat('%b %e %Y', this.x) +
                                '<br />' +
                                y;
                    }

                }
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: false
                    }
                },
                series: {
                    marker: false
                }
            },
            legend: legendOptions(),
            credits: {
                enabled: false
            },
            exporting: false,
            series: seriesSet,
            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            y: 0,
                            width: '78%',
                        }
                    }
                }]
            }

        });

        if (newDesign && currentChart.floatingLegend && seriesSet.length > 1) {
            var uniqueId = $(containerElm).parent().find('.chart-legend-container').attr('id');
            
            $(containerElm).on('click', '.highcharts-legend-item', function() {
                var $legendItem = $(this);
                var seriesIndex = $legendItem.index();
                
                setTimeout(function() {
                    if (chart.series && chart.series[seriesIndex]) {
                        var isVisible = chart.series[seriesIndex].visible;
                        $('#' + uniqueId + ' input[type="checkbox"]').eq(seriesIndex).prop('checked', isVisible);
                    }
                }, 10);
            });
            
            $('#' + uniqueId + ' .custom-legend').on('click', function(e) {
                if ($(e.target).closest('.legend-item').length > 0) {
                    return;
                }
                
                const $items = $(this).find('.legend-items');
                const $toggle = $(this).find('.legend-toggle');
                
                if ($items.hasClass('expanded')) {
                    $items.removeClass('expanded');
                    $toggle.css('transform', 'rotate(0deg)');
                } else {
                    $items.addClass('expanded');
                    $toggle.css('transform', 'rotate(180deg)');
                }
            });

            $('#' + uniqueId + ' .legend-item').each(function() {
                const $item = $(this);
                const seriesIndex = parseInt($item.attr('data-series-index'));
                const $checkbox = $item.find('input[type="checkbox"]');
                
                $checkbox.on('change', function() {
                    if (!chart.series || !chart.series[seriesIndex]) {
                        return;
                    }
                    
                    const series = chart.series[seriesIndex];
                    
                    if (typeof series.setVisible === 'function') {
                        series.setVisible(this.checked);
                    }
                });
                
                $item.on('click', function(e) {
                    if (e.target.tagName !== 'INPUT') {
                        e.preventDefault();
                        $checkbox.prop('checked', !$checkbox.prop('checked')).trigger('change');
                    }
                });
            });
        }

        return chart;
    },

    getXAxisLabels: function (currentChart){
       var xAxisLabelsOptions = {
            type: 'datetime',
            enabled: true,
            style: {
            fontSize: '11px',
                color: '#323232'
            },
            gridLineWidth: 0
        };

       xAxisLabelsOptions.format = currentChart.xAxisLabelFormat;
       return xAxisLabelsOptions;
    },

    getYAxisLabels: function (currentChart){
        var yAxisLabelsOptions = {
            overflow: 'justify',
            style: {
                color: '#323232'
            }
        };

        if(currentChart.yAxisLabelsFormatter){
            yAxisLabelsOptions.formatter = currentChart.yAxisLabelsFormatter;
        }else{
            yAxisLabelsOptions.format = currentChart.tooltipPrefix + '{value}';
        }

        return yAxisLabelsOptions;
    },

    getPricePeriods: function (inceptionDate, chartSettings) {
        var today = new Date();
        if (typeof inceptionDate != "object" || +inceptionDate > +today){ console.error("Need a valid inception date"); return [];}
        //var diff = today - inceptionDate;
        var periods = [];
        //var SinceInceptionText = ve10kChartOverrides?.SinceInceptionText ?? "Since Inception";

        var threeMonths = new Date(new Date().setMonth(new Date().getMonth() - 3));
        var sixMonths = new Date(new Date().setMonth(new Date().getMonth() - 6));
        var oneYear = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
        var threeYear = new Date(new Date().setFullYear(new Date().getFullYear() - 3));
        var fiveYear = new Date(new Date().setFullYear(new Date().getFullYear() - 5));
        var tenYear = new Date(new Date().setFullYear(new Date().getFullYear() - 10));

        switch(true) {
            case (+inceptionDate < +tenYear):
                if(!chartSettings.isSpa || chartSettings.isTenYearsLinkVisible) {
                    periods.push({
                        id: "tenYear",
                        name: window.ve10kChartOverrides?.TenYearText ?? "10 Years",
                        startDate: tenYear
                    });
                }
            case (+inceptionDate < +fiveYear):
                if(!chartSettings.isSpa || chartSettings.isFiveYearsLinkVisible) {
                    periods.push({
                        id: "fiveYear",
                        name: window.ve10kChartOverrides?.FiveYearText ?? "5 Years",
                        startDate: fiveYear
                    });
                }
            case (+inceptionDate < +threeYear):
                if(!chartSettings.isSpa || chartSettings.isThreeYearsLinkVisible) {
                    periods.push({
                        id: "threeYear",
                        name: window.ve10kChartOverrides?.ThreeYearText ?? "3 Years",
                        startDate: threeYear
                    });
                }
            case (+inceptionDate < +oneYear):
                if(!chartSettings.isSpa || chartSettings.isOneYearLinkVisible) {
                    periods.push({
                        id: "oneYear",
                        name: window.ve10kChartOverrides?.OneYearText ?? "1 Year",
                        startDate: oneYear
                    });
                }
            case (+inceptionDate < +sixMonths):
                if(!chartSettings.isSpa || chartSettings.isSixMonthLinkVisible) {
                    periods.push({
                        id: "sixMonths",
                        name: window.ve10kChartOverrides?.SixMonthText ?? "6 Months",
                        startDate: sixMonths
                    });
                }
            case (+inceptionDate < +threeMonths):
                if(!chartSettings.isSpa || chartSettings.isThreeMonthLinkVisible) {
                    periods.push({
                        id: "threeMonths",
                        name: window.ve10kChartOverrides?.ThreeMonthText ?? "3 Months",
                        startDate: threeMonths
                    });
                }
        }

        periods.reverse();

        if(!chartSettings.isSpa || chartSettings.isInceptionLinkVisible) {
            periods.push({
                id: "sinceInception",
                name: (window.ve10kChartOverrides?.IsEuFund || (window.ve10kChartOverrides?.IsLatam && !window.ve10kChartOverrides?.IsDefaultCulture)) && window.ve10kChartOverrides?.SinceInceptionText ? window.ve10kChartOverrides?.SinceInceptionText : "Inception",
                startDate: inceptionDate
            });
        }

        return periods;

    }


}
